module.exports = __webpack_public_path__ + "static/img/logo-zl.2a67cf3e.png";